module.exports = "/_next/static/images/Belanja_di_Toko_Website-Banner-c698ab3d2ab6ff8c2bc69f430e0cd53a.jpg";